import { analytics, db, storage, auth, authProvider,
         adminDbPath, usersDbPath, imageDataDbPath } from "../firebaseConfig"
import "./App.css"
import { addDoc, collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore"
import { getDownloadURL, ref } from "firebase/storage"
import { useEffect, useState } from "react"
import { signInWithRedirect } from "firebase/auth"
import { NavLink } from "react-router-dom"
//import * as Image from "./components/image"


const usersCollectionRef = collection(db, usersDbPath)

var uid = ""
var credential = ""
var userData = undefined
var images = []


// main App function
export default function App() {
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        // user is now signed in
        console.log("auth state is signed in")

        uid = user.uid
        credential = user.credential
        document.getElementById('sign-in-status').textContent = 'Signed in'
        document.getElementById('sign-in-button').textContent = 'Sign out'

        getUserImages(uid)

      } else {
        // user is now signed out
        console.log("auth state is signed out")

        // TODO: make reset_variables() method that is called on sign out
        uid = ""
        credential = ""
        document.getElementById('sign-in-status').textContent = 'Signed out'
        document.getElementById('sign-in-button').textContent = 'Sign in with Google'
      }
    })
  }, [])
  
  // TODO: remove eventually
  const [users, setUsers] = useState([])
  useEffect(() => {
    const getUsers = async () => {
      const data = await getDocs(usersCollectionRef)
      setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    getUsers()
  }, [])
  
  
  const [newOwnerID, setTransferOwner] = useState("")
  const [transferItemID, setTransferID] = useState("")
  const transferImage = async () => {
    // TODO: handle empty input checks
    if (auth.currentUser && images.includes(transferItemID)) {
      // the current user owns the image
      //let image = new Image(transferID)
      //image.transfer(transferOwner)
      console.log("transferring image #%s to user %s", transferItemID, newOwnerID)
    } else {
      console.warn("user does not own image #", transferItemID)
    }
  }
  
  
  // // main App return
  // return (
  //   <div className="App">
      
  //     <div className="Transfer">
  //       <input
  //         placeholder="Image ID..."
  //         onChange={(event) => {
  //           setTransferID(event.target.value)
  //         }}
  //         />
  //       <input
  //         placeholder="User ID..."
  //         onChange={(event) => {
  //           setTransferOwner(event.target.value)
  //         }}
  //         />
  //       <button onClick={transferImage}>Transfer Image</button>
  //     </div>

  //     <h1 id="sign-in-status">Signed out</h1>
  //     <button
  //       id="sign-in-button"
  //       onClick={toggleSignIn}
  //       >Sign in with Google
  //     </button>

  //     { 
  //       // TODO: replace this with displaying images for gallery? how to make grid view?
  //       /*users.map((user) => {
  //         return (
  //           <div>
  //             {""}
  //             <h1>{user.name}</h1>
  //             <h1>{user.images}</h1>
  //           </div>
  //         )
  //       })*/
  //     }

  //     { /* navigation bar that persists on all pages - <nav>? - navbar class? */}
  //     {/* <div className="PageSelector">
  //       <h1>TEST HEADER</h1>
  //       <ul>
  //         <li>
  //           <NavLink
  //             to="/"
  //             //style={ ({ isActive }) => isActive ? "bold" : undefined }
  //             >
  //               Home
  //             </NavLink>
  //         </li>
  //         <li>
  //           <NavLink to="/profile">Profile</NavLink>
  //         </li>
  //         <li>
  //           <NavLink to="/trade">Trade</NavLink>
  //         </li>
  //       </ul>
  //     </div> */}

  //   </div>
  // ) // end of main App return

  const [imageMap, setImageMap] = useState([])
  while (links.length < 30) {
    getRandomImage(links, setImageMap)
  }
  //setImageMap(links)

  return (
    <div className="App">
      <h1><b>All of these images were generated by our custom image algorithms!</b></h1>
      <h1><b>Refresh the page to see more of them!</b></h1>
      <div className="row">
        <div className="column">
          <img src={links.at(0)} alt="" />
          <img src={links.at(1)} alt="" />
          <img src={links.at(2)} alt="" />
          <img src={links.at(3)} alt="" />
          <img src={links.at(4)} alt="" />
        </div> 
        <div className="column">
          <img src={links.at(5)} alt="" />
          <img src={links.at(6)} alt="" />
          <img src={links.at(7)} alt="" />
          <img src={links.at(8)} alt="" />
          <img src={links.at(9)} alt="" />
        </div>
        <div className="column">
          <img src={links.at(10)} alt="" />
          <img src={links.at(11)} alt="" />
          <img src={links.at(12)} alt="" />
          <img src={links.at(13)} alt="" />
          <img src={links.at(14)} alt="" />
        </div>
        <div className="column">
          <img src={links.at(15)} alt="" />
          <img src={links.at(16)} alt="" />
          <img src={links.at(17)} alt="" />
          <img src={links.at(18)} alt="" />
          <img src={links.at(19)} alt="" />
        </div>
      </div>
      <h3>Website and images created by CHE Computer Science Club</h3>
    </div>
  ) // App return
}

var loadedImages = []
var links = []
async function getRandomImage(links, setImageMap) {
  let rand
  do {
    rand = Math.floor(Math.random() * (990 - 10) + 1)
  } while (loadedImages.includes(rand))
  loadedImages.push(rand)
  
  let path = rand.toString()
  while (path.length < 6) {
    path = "0" + path
  }


  /*let url = await getDownloadURL(ref(storage, `images/${path}.png`)).then((res) => {
    //console.log(url)
    let temp = links
    temp.push(res)
    setImageMap(temp)
    console.log(links.length, links)
  })*/
  
  links.push(`https://firebasestorage.googleapis.com/v0/b/checsclub.appspot.com/o/images%2F${path}.png?alt=media`)
  //console.log(links)
}



// handle signing in and out based on current sign in state
function toggleSignIn() {
  if (!auth.currentUser) {
    // user is trying to sign in
    console.log("user is signing in")
    signInWithRedirect(auth, authProvider).catch((error) => {
      /*var errorCode = error.code
      var errorMessage = error.message
      var email = error.email
      var credential = error.credential*/
      console.error(error)
    })
  } else {
    // user is trying to sign out
    auth.signOut()
  }
}

// get all images owned by the current user
async function getUserImages(id) {
  const userSnapshot = await getOrCreateUserSnapshot(id)
  userData = userSnapshot.data()
  //console.log("userData: ", userData)
  images = userData.images
  //console.log("images: ", images)
}

// get user's database entry
async function getOrCreateUserSnapshot(id) {
  let userDoc = await getDoc(doc(usersCollectionRef, id)).then((res) => {
    if (!res.exists()) {
      // user doc does not exist, so create a new one and return it
      console.log("could not find user with id: ", id)
      // TODO: how to get user's custom name?
      createUserDoc(id, auth.currentUser.displayName)
      return getOrCreateUserSnapshot(id)
    }

    // user doc exists, so proceed
    return res

  }).catch((err) => {
    console.error("error while getting or creating user data snapshot: ", err)
  })

  return userDoc
}

// create an empty entry in the database for a user
async function createUserDoc(id, name) {
  console.log("creating db entry for id: ", id)
  await setDoc(doc(db, usersDbPath, id), { name: name, images: [] })
}

